// SampleCardsSection.js

import React, { useState } from 'react';
import SampleCard from './SampleCard';
import SampleDetail from './SampleDetail';
import './SampleCardsSection.css';

// Let's use a clearer name for the prop, 'orders'. The parent will pass <SampleCardsSection orders={...} />
const SampleCardsSection = ({ samples, onRefreshData }) => {
    // State to manage which order is selected for the detail view.
    const [selectedOrder, setSelectedOrder] = useState(null);

    // This function is passed to the SampleCard and is called when a card is clicked.
    const handleCardClick = (order) => {
        console.log('SampleCardsSection: Card clicked for order:', order.id);
        setSelectedOrder(order);
    };

    // This function is passed to the modal to close it.
    const handleCloseDetail = () => {
        setSelectedOrder(null);
    };

    // This component no longer needs its own 'samples' state or useEffect.
    // It can render directly from the 'samples' prop.

    return (
        <div className="samplemanager-cards-section">
            {/* We now map directly over the 'samples' prop. */}
            {Array.isArray(samples) && samples.length > 0 ? (
                samples.map(order => (
                    <SampleCard 
                        key={order.id} // Use the unique order ID
                        sample={order} // Pass the order object to the card
                        onClick={handleCardClick}
                    />
                ))
            ) : (
                <div className="samplemanager-no-results">
                    <p>No orders match your search criteria.</p>
                </div>
            )}
            
            {/* The modal rendering logic is correct. */}
            {selectedOrder && (
                <SampleDetail 
                    order={selectedOrder} // Pass the selected order to the detail modal
                    onClose={handleCloseDetail}
                    onSaveChanges={() => {
                        handleCloseDetail(); // Close the modal first
                        if (onRefreshData) {
                            onRefreshData(); // Then refresh the data
                        }
                    }}
                />
            )}
        </div>
    );
};

export default SampleCardsSection;